import { jsonApi } from '@models/jsonApi';

jsonApi.define('tms/js-hosting', {
  id: null,
  url: '',
  file_name: '',
  checksum: '',
  status: 'inactive',
  urls: [],
  created_at: null,
  updated_at: null,
  deployed_at: null,
});
